import { lazy } from 'react';
import { useTranslation } from 'react-i18next';

import { GetPlayerProfileResponse } from 'services/players';

import styles from './other-players-section.module.scss';

const CardSlider = lazy(
	() => import('core/generic/components/general/card-slider')
);
const PlayerCard = lazy(
	() => import('core/generic/components/cards/player-card')
);

type OtherPlayersSectionProps = {
	position: string;
	isEsportsTeam: boolean;
	players: GetPlayerProfileResponse['playersInPosition'];
	backgroundImage?: string | null;
};

export const OtherPlayersSection = ({
	position,
	isEsportsTeam,
	players,
	backgroundImage,
}: OtherPlayersSectionProps) => {
	const { t } = useTranslation();
	const heading = t(
		`players_profile.heading_other_${position}`,
		isEsportsTeam
			? `Other ${position} players`
			: `Other ${position.toLowerCase()}s`
	);
	return (
		<section className={styles['other-players-section']} data-theme="dark">
			<div className="container">
				<div className="row">
					<div className="col-12">
						<CardSlider title={heading}>
							{players.map((player) => (
								<li key={player.id}>
									<PlayerCard
										playerData={player}
										backgroundImage={
											backgroundImage || undefined
										}
									/>
								</li>
							))}
						</CardSlider>
					</div>
				</div>
			</div>
		</section>
	);
};
